import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import { Input } from '@/components/ui/Input';
import { Label } from '@/components/ui/Label';

interface CreateTokenModalProps {
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
  tokenName: string;
  onChangeTokenName: (tokenName: string) => void;
  onCreate: () => void;
}

export function CreateTokenModal({
  open,
  onChangeTokenName,
  onCreate,
  onOpenChange,
  tokenName,
}: CreateTokenModalProps) {
  const { t } = useTranslation('translation', {
    keyPrefix:
      'pages.Settings.components.AppTokens.components.CreateTokenModal',
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>

          <DialogDescription>{t('description')}</DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <Label htmlFor="token-name">{t('tokenNameLabel')}</Label>
          <Input
            id="token-name"
            value={tokenName}
            onChange={(e) => onChangeTokenName(e.target.value)}
            placeholder={t('tokenNameplaceholder')}
            className="mt-1"
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('cancelButton')}
          </Button>
          <Button onClick={onCreate}>{t('createButton')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
